import { getApiClient } from './apiClient';

const WHATSAPP_BASE = '/whatsapp';

export const whatsappApi = {
  listBusinessAccounts: async () => {
    const client = getApiClient();
    const response = await client.get(`${WHATSAPP_BASE}/list-business-accounts`);
    return response.data;
  },

  addBusinessAccount: async (payload) => {
    const client = getApiClient();
    const response = await client.post(`${WHATSAPP_BASE}/add-business-account`, payload);
    return response.data;
  },

  listMetaPhoneNumbers: async (businessAccountId, limit = 25, after = null) => {
    const client = getApiClient();
    const response = await client.get(`${WHATSAPP_BASE}/list-phone-numbers`, {
      params: { businessAccountId, limit, after },
    });
    return response.data;
  },

  savePhoneNumber: async (payload) => {
    const client = getApiClient();
    try {
      const response = await client.post(`${WHATSAPP_BASE}/save-phone-number`, payload);
      return response.data;
    } catch (error) {
      const message = error?.response?.data;
      throw new Error(typeof message === 'string' ? message : 'Failed to save phone number');
    }
  },

  listMetaTemplates: async (businessAccountId, limit = 25, after = null, name = null) => {
    const client = getApiClient();
    const response = await client.get(`${WHATSAPP_BASE}/list-meta-templates`, {
      params: { businessAccountId, limit, after, name },
    });
    return response.data;
  },

  saveTemplate: async (payload) => {
    const client = getApiClient();
    const response = await client.post(`${WHATSAPP_BASE}/save-template`, payload);
    return response.data;
  },

  listSavedTemplates: async (businessAccountId) => {
    const client = getApiClient();
    const response = await client.get(`${WHATSAPP_BASE}/list-saved-templates`, {
      params: { businessAccountId },
    });
    return response.data;
  },

  uploadMedia: async ({ phoneNumberId, type, file }) => {
    const client = getApiClient();
    const formData = new FormData();
    formData.append('phoneNumberId', phoneNumberId);
    formData.append('type', type);
    formData.append('file', file);

    const response = await client.post(`${WHATSAPP_BASE}/upload-media`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  listSavedPhoneNumbers: async (businessAccountId) => {
    const client = getApiClient();
    const response = await client.get(`${WHATSAPP_BASE}/list-saved-phone-numbers`, {
      params: { businessAccountId },
    });
    return response.data;
  },

  listConversations: async (phoneNumberId, search = '', page = 0, limit = 20) => {
    const client = getApiClient();
    const response = await client.get(`${WHATSAPP_BASE}/conversations`, {
      params: { phoneNumberId, search, page, limit },
    });
    return response.data;
  },

  listConversationMessages: async (conversationId, page = 0, limit = 50) => {
    const client = getApiClient();
    const response = await client.get(`${WHATSAPP_BASE}/conversation-messages`, {
      params: { conversationId, page, limit },
    });
    return response.data;
  },

  markMessageAsRead: async (payload) => {
    const client = getApiClient();
    const response = await client.post(`${WHATSAPP_BASE}/mark-message-read`, payload);
    return response.data;
  },

  updateConversationProfileName: async (payload) => {
    const client = getApiClient();
    const response = await client.post(`${WHATSAPP_BASE}/update-conversation-profile-name`, payload);
    return response.data;
  },

  sendMessage: async (payload) => {
    const client = getApiClient();
    const response = await client.post(`${WHATSAPP_BASE}/send-message`, payload);
    return response.data;
  },

  sendTemplateMessage: async (payload) => {
    const client = getApiClient();
    const response = await client.post(`${WHATSAPP_BASE}/send-template-message`, payload);
    return response.data;
  },
};

export default whatsappApi;

